import toast from "react-hot-toast";
import moment from "moment";

export const selectStyles = {
  container: () => ({
    position: "relative",
    minWidth: "100%",
    maxWidth: "auto"
  }),
  menuList: defaultStyle => ({
    minWidth: "250px",
    maxHeight: "250px",
    overflowY: "scroll"
  }),
  menuPortal: defaultStyle => ({
    minWidth: "250px",
    maxHeight: "250px",
    overflowY: "scroll"
  }),
  menu: (defaultStyle, state) => {
    return {
      ...defaultStyle,
      minWidth: "250px",
      top: "64px"
    };
  }
};

export const selectTheme = theme => {
  return {
    ...theme,
    borderRadius: "5px",
    colors: {
      ...theme.colors,
      primary: "#677F62",
      primary25: "#A4C39C",
      primary50: "#677F62",
      primary75: "#677F62",
      neutral0: "#FFFFFF",
      neutral5: "#FFFFFF"
    }
  };
};

export const notify = (type, message) => {
  if (type === "success") {
    toast.success(message, {
      iconTheme: {
        primary: "#3E4E3A"
      }
    });
  } else {
    toast[type](message);
  }
};

export const copyToClipboard = text => {
  navigator.clipboard.writeText(text).then(
    () => {
      /* clipboard successfully set */
      notify("success", "Copié dans le presse-papier !");
    },
    () => {
      notify("error", "Erreur lors de la copie dans le presse-papier !");
    }
  );
};

export const excelDateToJSDate = serial => {
  var utc_days = Math.floor(serial - 25569);
  var utc_value = utc_days * 86400;
  var date_info = new Date(utc_value * 1000);

  var fractional_day = serial - Math.floor(serial) + 0.0000001;

  var total_seconds = Math.floor(86400 * fractional_day);

  var seconds = total_seconds % 60;

  total_seconds -= seconds;

  var hours = Math.floor(total_seconds / (60 * 60));
  var minutes = Math.floor(total_seconds / 60) % 60;

  return new Date(
    date_info.getFullYear(),
    date_info.getMonth(),
    date_info.getDate(),
    hours,
    minutes,
    seconds
  );
};

export const stringDateToJSDate = str => {
  return moment(str, "DD/MM/YYYY").toDate();
};

export const formatNumber = (number, currency) => {
  return `${number.toLocaleString("fr-FR")} ${currency}`;
};

export const crispSendMessage = () => {
  window.$crisp.push([
    "do",
    "message:send",
    ["text", "Bonjour, j'ai besoin d'aide !"]
  ]);
  window.$crisp.push(["do", "chat:open"]);
};
